import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dimmer, Grid, Loader } from 'semantic-ui-react';
import * as classnames from 'classnames';
import { find } from 'lodash';
import StimuliCarousel from './StimuliCarousel';
import { startLayerProcess, getAnalysisDataSet, getProcessVideoData } from '../../data/analysis/layersDispatchers';
import VisualisationsHelper from '../../lib/VisualisationsHelper';

import HeatMap from './visualisations/HeatMap';
import Exports from './visualisations/Exports';
import Video from './visualisations/Video';

class Visualisations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartsLoading: false,
      processDisabled: true
    };

    this.processLayer = this.processLayer.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      processDisabled: !VisualisationsHelper.canProcess(
        nextProps.analysisModeSelected.id,
        nextProps
      )
    };
  }

  processLayer(e) {
    if (!this.state.processDisabled) {
      if (
        this.props.analysisModeSelected.id === 'heatMap' ||
        this.props.analysisModeSelected.id === 'dataExportation'
      ) {
        this.props.dispatch(startLayerProcess(this.props.layer, this.props.selectedStimuliId));
      } 
      else if(this.props.analysisModeSelected.id === 'video'){
        this.props.dispatch(getProcessVideoData('video'));
      } else {
        this.props.dispatch(getAnalysisDataSet(this.props.project.id));
      }
    }
  }

  render() {
    console.log("PROPS", this.props);
    const { processDisabled, chartsLoading } = this.state;
    const { analysisModeSelected } = this.props;

    const processLayerClasses = classnames({
      disabled: processDisabled,
      processLayer: true,
      clickable: !processDisabled
    });

    let visualisation;
    let processButtonLabel;

    switch (analysisModeSelected.id) {
      case 'heatMap':
        visualisation = <HeatMap />;
        processButtonLabel = 'Process Layer';
        break;
      case 'dataExportation':
        visualisation = <Exports />;
        processButtonLabel = 'Export Data';
        break;
      case 'video':
        visualisation = <Video url='' />;
        processButtonLabel = 'Video'
        break;
      default:
        visualisation = null;
        processButtonLabel = 'Process Layer';
    }

    return (
      <Grid.Column width={9} className="visualData">
        <Grid>
          <Grid.Row className="columnHeader">
            <Grid.Column width={3}>
              <div style={{ display: 'none' }}>Sea Level</div>
            </Grid.Column>
            <Grid.Column width={7}>
              <div style={{ display: 'none' }}>
                Export:
                <i className="icon icon-link round-icon" />
                <i className="icon icon-file-text2 round-icon" />
              </div>
            </Grid.Column>
            <Grid.Column width={6} className={processLayerClasses} onClick={this.processLayer}>
              <div>{processButtonLabel}</div>
            </Grid.Column>
          </Grid.Row>
          {analysisModeSelected.id === 'heatMap' && (
            <Grid.Row>
              <Grid.Column className="stimuliCarouselColumn">
                <StimuliCarousel />
              </Grid.Column>
            </Grid.Row>
          )}

          <Grid.Row className="visuaDataContent">
            <Grid.Column>
              <Grid>
                <Grid.Row className="visualDataSubHeader">
                  <Grid.Column>
                    <div>{analysisModeSelected ? analysisModeSelected.label : ''}</div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <div id="chartsContainerWrapper">
                    <Dimmer active={chartsLoading}>
                      <Loader />
                    </Dimmer>
                    {visualisation}
                  </div>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active,
  analysisModeSelected: state.analysis.single.analysisModes.find(m => m.selected === true),
  chartsData: state.analysis.single.chartsData,
  selectedStimuliId: state.analysis.single.selectedStimuliId,
  layer: (() => {
    const { activeLayerId } = state.analysis.single;
    return find(state.analysis.single.layers, { id: activeLayerId });
  })(),
  journeyMap: state.analysis.data.journeyMap,
  aggregateJourneyMap: state.analysis.data.aggregateJourneyMap,
  circumplex: state.analysis.data.circumplex
}))(Visualisations);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/Visualisations.js